import React from "react";
import ReportList from "../../ReportList";
import "./reports-page.css";

const ReportsPage = () => {
  return (
    <div className="reports-page">
      <div className="reports-page__header">
        <h1 className="reports-page__title">Звіти</h1>
        <p className="reports-page__subtitle">Перегляд звітів за вибраний період</p>
      </div>
      <ReportList />
    </div>
  );
};

export default ReportsPage;
